import React from 'react'
import { Card, CardContent, Divider, Grid } from '@material-ui/core'
import { components, constants, useTranslation } from 'cng-web-lib'

import Namespace from 'src/constants/locale/Namespace'
import NBSChargeCodeMappingApiUrls from 'src/apiUrls/NBSChargeCodeMappingApiUrls'
import NBSChargeCodeMappingKeys from "../../../../constants/locale/key/NBSChargeCodeMapping";

const {
  card: {CngSimpleCardHeader},
  table: { CngCrudTable, useDefaultNotification, useFetchCodeMaintenanceLookup}
} = components
const { locale: {key: {UiComponentKeys} }, EQUAL } = constants

function TablePage(props){

  const { location: { pathname }, showNotification } = props

  const notification = useDefaultNotification(showNotification)
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()

  const { translate } = useTranslation([
    Namespace.UI_COMPONENT, Namespace.NBS_CHARGE_CODE_MAPPING
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject(){
    let title = translate(Namespace.NBS_CHARGE_CODE_MAPPING, NBSChargeCodeMappingKeys.TITLE)

    let tableTitle = translate(
        Namespace.UI_COMPONENT,
        UiComponentKeys.Table.TITLE,
        { nameTitleised: title}
    )

    // columns
    let chargeCode = translate(Namespace.NBS_CHARGE_CODE_MAPPING, NBSChargeCodeMappingKeys.FIELDS.CHARGE_CODE)
    let countType = translate(Namespace.NBS_CHARGE_CODE_MAPPING, NBSChargeCodeMappingKeys.FIELDS.COUNT_TYPE)
    let postingFreq = translate(Namespace.NBS_CHARGE_CODE_MAPPING, NBSChargeCodeMappingKeys.FIELDS.POSTING_FREQ)

    return {
      tableTitle,
      chargeCode,
      countType,
      postingFreq
    }
  }

  //* Table Columns
  const columns = [
    {
      field: 'chargeCode',
      title: translatedTextsObject.chargeCode,
      customLookup: () => {
        return fetchCodeMaintenanceLookup(
            constants.CodeMaintenanceType.CODE_MASTER,
            (error) => console.error(error),
            [{ field: 'codeType', operator: EQUAL, value: 'CAL_NBS_CHARGECODE' }]
        )
      }
    },
    {
      field: 'countType',
      title: translatedTextsObject.countType,
      customLookup: () => {
        return fetchCodeMaintenanceLookup(
            constants.CodeMaintenanceType.CODE_MASTER,
            (error) => console.error(error),
            [{ field: 'codeType', operator: EQUAL, value: 'CAL_NBS_COUNT_TYPE' }]
        )
      }
    },
    {
      field: 'postingFreq',
      title: translatedTextsObject.postingFreq,
      customLookup: () => {
        return fetchCodeMaintenanceLookup(
            constants.CodeMaintenanceType.CODE_MASTER,
            (error) => console.error(error),
            [{ field: 'codeType', operator: EQUAL, value: 'CAL_NBS_POST_FRE' }]
        )
      }
    }
  ];

  //* return JSX
  return (

      //* Start JSX
      <Card>
        <CngSimpleCardHeader title={translatedTextsObject.tableTitle}/>
        <Divider/>
        <CardContent>
          <Grid container spacing = {3}>
            <Grid item xs={12}>
              <CngCrudTable {...props}
                            notification = {notification}

                  // table fetch and data details
                            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
                            fetch={{ url: NBSChargeCodeMappingApiUrls.GET}}
                            idAccessor='id'
                            columns={columns}

                  // view route
                            viewRoute={`${pathname}/view`}

                  // edit route
                            editRoute={`${pathname}/edit`}

                  // add route
                            addRoute={`${pathname}/add`}

                  // delete
                            del={{ url: NBSChargeCodeMappingApiUrls.DELETE}}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      //* End JSX
  );
  //* End of function
}

export default TablePage